'use strict';

import React from 'react';
import QueryRule from './queryRule.component';
import QueryGroup from './queryGroup.component';

class QueryBuilder extends React.Component {

  renderQueryRule (item, otherProps) {
    return (
      <QueryRule
        key={item.name}
        item={item}
        handleDeleteButtonOnClick={otherProps.handleDeleteButtonOnClick}
        entitiesSuggestion={otherProps.entitiesSuggestion}
        handleSuggestionsAutocompleteSelect={otherProps.handleSuggestionsAutocompleteSelect}
        handleSuggestionsAutocompleteOnChange={otherProps.handleSuggestionsAutocompleteOnChange}
        handleSuggestionsAutocompleteKeyPress={otherProps.handleSuggestionsAutocompleteKeyPress}/>
    );
  }

  renderQueryTool (queryTree, otherProps) {
    const queryGroup = queryTree.map((item) => {
      if (item.type === 'rule') return this.renderQueryRule(item, otherProps);
      else
        return (
          <QueryGroup
            key={item.name}
            className="BreakLine"
            shoulDelete={!!item.shoulDelete}
            item={item}
            handleAddRuleButtonOnClick={otherProps.handleAddRuleButtonOnClick}
            handleAddGroupButtonOnClick={otherProps.handleAddGroupButtonOnClick}
            handleDeleteButtonOnClick={otherProps.handleDeleteButtonOnClick}
            handleButtonGroupOnClick={otherProps.handleButtonGroupOnClick}>
            { this.renderQueryTool(item.children, otherProps) }
          </QueryGroup>
        );
    });
    return queryGroup;
  }

  render() {
    const { queryTree, queryTerm, ...otherProps } = this.props;

    return (
      <div>
        <div className="BreakLine">
          <div className="EntityShowCase" style={{marginBottom: 0}}>
            { queryTerm.length < 15 ? 'Use the builder below to create a search query.' : queryTerm }
          </div>
        </div>
        {this.renderQueryTool(queryTree, otherProps)}
      </div>
    );
  }
}

export default QueryBuilder;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/queryBuilder/queryBuilder.component.jsx